// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const PurchaseDetailClient = registerClientReference(
    function() { throw new Error("Attempted to call PurchaseDetailClient() from the server but PurchaseDetailClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(buyer)/purchases/[id]/purchase-detail-client.tsx",
    "PurchaseDetailClient",
);
